import styled from 'styled-components'

export const ExpandedWrap = styled.div`
  border-top: 2px solid ${p => p.theme.colors.scale[200]};
  background: ${p => p.theme.colors.gray[50]};
  padding: 16px 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  @media (max-width: 768px) { grid-template-columns: 1fr; }
`

export const HistSection = styled.section``

export const HistTitle = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${p => p.theme.colors.scale[600]};
  margin-bottom: 8px;
`

export const HistList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid ${p => p.theme.colors.scale[200]};
  border-radius: 5px;
  overflow: hidden;
  background: #fff;
`

export const HistItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 10px;
  font-size: 12px;
  border-bottom: 1px solid ${p => p.theme.colors.gray[100]};
  &:last-child { border-bottom: none; }
`

export const HistDate = styled.span`
  flex-shrink: 0;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 600;
  background: ${p => p.empty ? 'transparent' : '#dcfce7'};
  color: ${p => p.empty ? '#9ca3af' : '#166534'};
  font-style: ${p => p.empty ? 'italic' : 'normal'};
`

export const ContactSelectWrap = styled.div`
  width: 100%;
`

export const AssinanteBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  flex-shrink: 0;
  font-size: 9px;
  font-weight: 700;
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fcd34d;
  border-radius: 20px;
  padding: 1px 6px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`
export const PackageBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  flex-shrink: 0;
  font-size: 9px;
  font-weight: 700;
  background: #c9c7fe;
  color: #170e92;
  border: 1px solid #614dfc;
  border-radius: 20px;
  padding: 1px 6px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`

export const TutorPetCount = styled.span`
  margin-top: 2px;
  font-size: 10px;
  font-weight: 400;
  line-height: 1.2;
  color: #f97316;
`
